import Vue from 'vue';
import Router from 'vue-router';

import routes from './routes';

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: routes
});

router.beforeEach((to, from, next) => {
  var login = !!(localStorage.getItem('login') && localStorage.getItem('login') === 'true' && localStorage.getItem('token'));

  if (!login && to.matched.some(record => record.meta.requiresAuth)) {
    next({ name: 'NotFound' });
  }

  // var isBundle = localStorage.getItem('is_bundle') == 'exit-popup';
  // if(isBundle && to.name != 'Login' && to.name != 'Items'){
  //   next({ name: 'Login' });
  // }

  if (to.path === '/') next({ name: 'Home' });

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js